<template>
	<v-container fluid>
		<div v-if="isLoaded">
			
			<!--table head-->
			<v-divider class="mt-4" color="black" />
			<v-row class="subtitle-2 mx-8" no-gutters>
				<v-col v-for="(item, i) in headers" :key="i"
					class="text-pre-wrap"
					:class="item.style">
					{{ `${item.text}` | localize }}
				</v-col>
			</v-row>
			<v-divider class="mt-4" color="black" />
			<!--table content-->
			<div v-if="spots?.length > 0">
				<!--tab content-->
				<v-expansion-panels focusable v-model="panel">
					<v-expansion-panel>
						<v-expansion-panel-header class="secondary--text">
							{{'Advertising (spots)' | localize }}
						</v-expansion-panel-header>
						<v-expansion-panel-content class="body-2">
							<div v-for="spot in spots" :key="spot.id">
								<v-row no-gutters>
									<v-col class="text-left">{{ spot.name }}</v-col>
									<v-col class="text-center">{{ spot.trademark.name }}</v-col>
									<v-col class="text-center">{{ spot.quality }}</v-col>
									<v-col class="text-center">{{ `${spot.objective}` | localize }}</v-col>
									<v-col class="text-center">{{ fromArr(spot.channels) }}</v-col>
									<v-col class="text-center">{{ formatNumber(spot.investments) }}</v-col>
									<v-col class="text-center">{{ formatNumber(spot.budget) }}</v-col>
									<v-col class="text-center">{{ formatNumber(spot.coverage_general) }}</v-col>
									<v-col class="text-center">{{ formatNumber(spot.coverage_targeted) }}</v-col>

									<v-col class="text-center">
										<v-tooltip bottom color="primary">
											<template v-slot:activator="{ on }">
												<v-btn v-on="on" text small class="text-lowercase">
													{{ shortName(spot.commercial_story?.text) }}
												</v-btn>
											</template>
											<div class="text-center width_250">
												{{ spot.commercial_story?.text }}
											</div>
										</v-tooltip>
									</v-col>

									<v-col class="text-right">
										<edit-spot :spot="spot" />
										<delete-spot :spot="spot" />
									</v-col>
								</v-row>
								<v-divider />
							</div>

						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</div>
			<v-row v-else class="mt-8 px-4" justify="center">
				You don't have advertising spots yet!
			</v-row>
			<v-row class="my-4 mx-8" justify="start">
				<add-spot />
			</v-row>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row>
	</v-container>
</template>
<script>
	import { serializing, localeNumber } from '../../../functions/common';
	import Loader from '../../../layouts/Loader.vue';

	export default {
		data (){
			return {
				icon: 'arrow_right',
				show: false,
				isLoaded: false,
				headers: [
					{ text: 'Spot name', style: 'text-left'},
					{ text: 'Trademark', style: 'text-center'},
					{ text: 'Quality level', style: 'text-center'},
					{ text: 'Objective', style: 'text-center'},
					{ text: 'Channels', style: 'text-center' },
					{ text: 'Investments', style: 'text-center'},
					{ text: 'Budget', style: 'text-center' },
					{ text: 'General coverage (persons)', style: 'text-center' },
					{ text: 'Targeted coverage (persons)', style: 'text-center' },
					{ text: 'Commercial story', style: 'text-center' },
					{ text: 'Actions', style: 'text-right'},
				],
				panel: 0,
				first_mount: true,
			}
		},		
		computed: {

			locale() {
				return this.$store.getters.locale;
			},
			team() {
				return this.$store.getters.team;
			},
			game() {
				return this.$store.getters.game;
			},
			spots() {
				return this.$store.getters.spots;
			},
		},
		methods: {
			fromArr (arr) {
				return serializing(arr)
			},
			formatNumber(num) {
				return localeNumber(num, this.locale);
			},
			shortName(str) {
				let res = ''
				if (str) {
					res = str.substr(0, 7) + '...';
				}
				return res;
			}
		},
		components: {
			addSpot: () => import('../../../components/team/promotion/addSpot.vue'),
			deleteSpot: () => import('../../../components/team/promotion/deleteSpot.vue'),
			editSpot: () => import('../../../components/team/promotion/editSpot.vue'),
			Loader
		},
		async created() {
			if (this.game && this.team) {

				const params = {
					gameId: this.game.id,
					round: this.game.round,
					teamId: this.team.id,
				}
				
				if (this.spots == null) {
					try {
						await this.$store.dispatch('fetchTeamSpots', params);
					}
					catch(error) {
						await this.$store.dispatch('setError', error.message);
					}
				}
				
				this.isLoaded = true;
			}
		}
	}
</script>
<style>
    .width_250 {
        width: 250px;
    }
</style>
